module.exports = __webpack_public_path__ + "static/media/listUniversity.116f32ee.svg";